// src/services/paymentService.js
import API from "../../../../app/api";

// Initiate Razorpay Payment
export const initiatePayment = async (payload) => {
  try {
    const response = await API.post("/checkout/payment-initiate", payload);
    return response.data;
  } catch (error) {
    console.error("Error initiating payment:", error.response?.data || error);
    return error.response?.data;
  }
};

// Verify Payment via Callback
export const verifyPayment = async (paymentId, orderId) => {
  try {
    const response = await API.get(
      `/checkout/payment/callback?payment_id=${paymentId}&order_id=${orderId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error verifying payment:", error.response?.data || error);
    throw error;
  }
};











